export default function BackToTop() {
  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="回到顶部"
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full border border-cinnabar-500/50 bg-night-800/80 text-parchment-200 backdrop-blur transition hover:bg-cinnabar-600 hover:text-parchment-100"
    >
      <i className="ri-arrow-up-line text-lg"></i>
    </button>
  );
}